
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcNotificationFloatingItem as ObcNotificationFloatingItemElement} from '@oicl/openbridge-webcomponents/dist/components/notification-floating-item/notification-floating-item.js';
 
 
 

 
 export const ObcNotificationFloatingItem = createComponent({
   react: React,
   tagName: 'obc-notification-floating-item',
   elementClass: ObcNotificationFloatingItemElement,
   events: {
     
     onActionClick: 'action-click' as EventName<CustomEvent<void>>,
     onAction2Click: 'action2-click' as EventName<CustomEvent<void>>,
     onDismissClick: 'dismiss-click' as EventName<CustomEvent<void>>,
   }
  });
 
 